module.exports = __webpack_public_path__ + "static/media/0026_Medium.bf09b731.jpg";